export const base = '/settings/:group?/:section?/:id?/:part?/:childId?';